import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const AtlassianIcon: React.FC<IconProps> = ({ size, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Samsung"
    role="img"
    style={style}
    width={size ?? '24px'}
    height={size ?? '24px'}
    viewBox="0 0 24 24"
    data-testid="atlassian-icon"
  >
    <path
      fill="#fff"
      d="M7.1 11.1c-.2-.3-.7-.4-1-.1 0 0-.2.2-.2.3L0 23c-.2.3 0 .8.3.9h8.5c.3 0 .5-.2.6-.4 1.8-3.6.7-9.2-2.4-12.5ZM11.4.4c-3 4.6-3.3 10.4-.9 15.3l4 7.9c.1.2.4.4.6.4h8.2c.4 0 .7-.4.7-.8V23L12.6.4c-.2-.3-.6-.5-.9-.3-.1 0-.2.2-.3.3Z"
    />
  </svg>
);
export default AtlassianIcon;
